interface ApiConfig {
  apiEndpoint: string;
  staticEndpoint: string;
}

export const apiConfig: ApiConfig = {
  apiEndpoint: 'https://api.conta-kun.4-two.com/v1',
  staticEndpoint: 'https://static.conta-kun.4-two.com/v1'
};
